import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment";
import momentTimezone from 'moment-timezone';
import { set, useForm, Controller, useFieldArray } from "react-hook-form";
import { Link } from 'react-router-dom';
import CardLayout from '../../../components/utils/CardLayout';
import SearchBar from '../../../components/utils/SearchBar';
import "react-datepicker/dist/react-datepicker.css";
import Table from '../../../components/utils/Table';
import Alert from '../../../components/utils/Alert';
import Tag from '../../../components/utils/Tag';
import SimSwapActions from '../../../redux/simSwapRequest/actions';
import CompleteSimSwapModalComponent from './CompleteForm';
import CancelSimSwapModalComponent from './CancelForm';
import Calendar2LineIcon from 'remixicon-react/Calendar2LineIcon';
import Button from '../../../components/utils/Button';
import DatePicker from "react-datepicker";
import shortCodeActions from '../../../redux/shortCodeData/actions'
import SideButtons from '../../../components/utils/SideButtons';
import SimSwapFormModal from './SimSwapFormModal';
import { isAdminOrAgent, isAdmin, isAdminAgent } from '../../../helpers/commonFunction';
import authActions from '../../../redux/auth/actions';
import useSocket from '../../../hooks/useSocket';
import SocketActions from '../../../redux/socket/actions'
import Modal from '../../../components/utils/Model'
import networkActions from '../../../redux/network/actions';
import dealerAction from '../../../redux/dealer/actions'
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';

const TIMEZONE = process.env.REACT_APP_TIMEZONE;
const LONG_TIME_FORMAT = process.env.REACT_APP_LONG_TIME_FORMAT;

const { getSimSwapRequest, lockSimSwapRequest, releaseLockSimSwapRequest, openCompleteSimSwapModal, openCancelSimSwapModal, openSimSwapFormModal, resetMessage, getMsisdnAvilable, updatePickedMsisdn, resetModalMessage, createActivationUsingSimSwap, refershMsisdn } = SimSwapActions;
const { getShortCode } = shortCodeActions;
const { getUserDataByToken } = authActions;
const { getSimSwapRequestForSocket } = SocketActions;
const { getActiveNetwork } = networkActions;
const { getDealer } = dealerAction;

function ActivationRequest() {
    const dispatch = useDispatch();
    const {
        simSwapRequestList,
        simSwapRequestLoading,
        simSwapRequestError,
        lockSimSwapRequestError,
        lockSimSwapRequestMessage,
        completeSimSwapModal,
        cancelSimSwapModal,
        cancelSimSwapRequestError,
        cancelSimSwapRequestMessage,
        createSimSwapRequestMessage,
        releaseLockSimSwapRequestMessage,
        releaseLockSimSwapRequestError,
        lockSimSwapRequestLoading,
        releaseLockSimSwapRequestLoading,
        completeSimSwapRequestMessage,
        mdnData, getMDNLoading, getMDNMessage, pickedMDNMessage, pickedMDNError, pickedMDNLoading,
        createActivationUsingSimSwapLoading, createActivationUsingSimSwapError, createActivationUsingSimSwapMessage
    } = useSelector((state) => state.simSwapRequest);
    const { shortCodeResult, shortCodeSimType } = useSelector((state) => state.shortCode);
    const { tokenData } = useSelector((state) => state.auth);
    const { networkResult } = useSelector((state) => state.network);
    const dealerResult = useSelector((state) => state.dealer.dealerResult);
    const [toDate, setToDate] = useState(new Date())
    const [fromDate, setFromDate] = useState(new Date(new Date().getTime() - 2 * 24 * 60 * 60 * 1000));
    const [filterText, setFilterText] = useState("");
    const [selectedRow, setSelectedRow] = useState(new Object());
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [selectedID, setSelectedID] = useState('');
    const [unlockID, setunlockID] = useState('');
    const [cancelID, setcancelID] = useState('');
    const [completeID, setcompleteID] = useState('');
    const [searchData, setSearchData] = useState({
        statusID: '10',
        serialNumber: '',
        fromDate: moment(fromDate).format("YYYY-MM-DD"),
        toDate: moment(toDate).format("YYYY-MM-DD"),
        dealerID: "",
        networkID: ""
    });
    const [statusData, setstatusData] = useState({
        tableName: "activationrequest",
        fieldName: "RequestStatus"
    });
    const [showPopup, setShowPopup] = useState(false);
    const [showMSISDNModel, setShowMSISDNModel] = useState(false);
    const [formTitle, setFormTitle] = useState('');
    const [formButton, setFormButton] = useState('');
    const [selectedMSISDN, setSelectedMSISDN] = useState('');
    const [simSwapID, setSimSwapID] = useState(null)
    const [showAlertModal, setShowAlertModal] = useState(false);

    const { register: registerFilter, handleSubmit: handleSubmit, formState: { errors: filterError }, watch, reset } = useForm({ defaultValues: searchData });
    const { register: registerregister, handleSubmit: handleMDNSubmit, formState: { errors: MsisdnError }, reset: resetReset } = useForm({ defaultValues: [] });

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    useSocket('lock sim swap request', () => {
        if (isAdmin(tokenData) || isAdminAgent(tokenData)) {
            dispatch(getSimSwapRequestForSocket(searchData));
        }
    });

    useSocket('remove msisdn from pool', (data) => {
        if (showMSISDNModel) {
            const updatedList = mdnData.filter(item => item.MSISDN !== data.msisdn);
            dispatch(refershMsisdn(updatedList));
        }
    });

    useEffect(() => {
        const newData = {
            ...searchData,
            toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
            fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
        };
        dispatch(getSimSwapRequest(newData));
        dispatch(getShortCode(statusData));
        dispatch(getActiveNetwork());
        dispatch(getDealer());
    }, [])

    useEffect(() => {
        if (createSimSwapRequestMessage || releaseLockSimSwapRequestMessage || lockSimSwapRequestMessage) {
            dispatch(dispatch(getSimSwapRequest(searchData)));
        }
    }, [createSimSwapRequestMessage, releaseLockSimSwapRequestMessage, lockSimSwapRequestMessage])

    useEffect(() => {
        if (cancelSimSwapRequestError !== null && cancelSimSwapRequestError !== undefined) {
            displayAlert(cancelSimSwapRequestError, 'alert-danger');
        }
        if (cancelSimSwapRequestMessage !== null && cancelSimSwapRequestMessage !== undefined) {
            displayAlert(cancelSimSwapRequestMessage, 'alert-success');
            dispatch(getUserDataByToken());
        }
        if (lockSimSwapRequestError !== null && lockSimSwapRequestError !== undefined) {
            displayAlert(lockSimSwapRequestError, 'alert-danger');
        }
        if (lockSimSwapRequestMessage !== null && lockSimSwapRequestMessage !== undefined) {
            displayAlert(lockSimSwapRequestMessage, 'alert-success');
        }
        if (completeSimSwapRequestMessage !== null && completeSimSwapRequestMessage !== undefined) {
            displayAlert(completeSimSwapRequestMessage, 'alert-success');
        }

        if (releaseLockSimSwapRequestError !== null && releaseLockSimSwapRequestError !== undefined) {
            displayAlert(releaseLockSimSwapRequestError, 'alert-danger');
        }
        if (releaseLockSimSwapRequestMessage !== null && releaseLockSimSwapRequestMessage !== undefined) {
            displayAlert(releaseLockSimSwapRequestMessage, 'alert-success');
        }
        if (simSwapRequestError !== null && simSwapRequestError !== undefined) {
            displayAlert(simSwapRequestError, 'alert-danger');
        }
        if (createSimSwapRequestMessage !== null && createSimSwapRequestMessage !== undefined) {
            displayAlert(createSimSwapRequestMessage, 'alert-success');
        }
        if (pickedMDNError !== null && pickedMDNError !== undefined) {
            displayAlertModal(pickedMDNError, 'alert-danger');
        }
        if (pickedMDNMessage !== null && pickedMDNMessage !== undefined) {
            displayAlert(pickedMDNMessage, 'alert-success');
            setSelectedMSISDN('')
            setShowMSISDNModel(false);
        }
        if (createActivationUsingSimSwapError !== null && createActivationUsingSimSwapError !== undefined) {
            displayAlertModal(createActivationUsingSimSwapError, 'alert-danger');
        }
        if (createActivationUsingSimSwapMessage !== null && createActivationUsingSimSwapMessage !== undefined) {
            displayAlert(createActivationUsingSimSwapMessage, 'alert-success');
            setShowMSISDNModel(false);
        }

    }, [simSwapRequestError, completeSimSwapRequestMessage, lockSimSwapRequestError, , releaseLockSimSwapRequestMessage, lockSimSwapRequestMessage, cancelSimSwapRequestError, cancelSimSwapRequestMessage, createSimSwapRequestMessage, pickedMDNError, pickedMDNMessage, createActivationUsingSimSwapError, createActivationUsingSimSwapMessage]);

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
        setShowAlertModal(false);
        dispatch(resetMessage())
    };

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        setShowAlertModal(false);
        dispatch(resetMessage())
    }

    const handleFilterChange = (value) => {
        setFilterText(value);
    };

    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'DATE', key: 'requestedDtTm' },
        { displayName: 'DP DEALER NAME', key: 'dpDealerName' },
        { displayName: 'ACTION', key: 'action' },
        { displayName: 'STATUS', key: 'status' },
        { displayName: 'NETWORK', key: 'NetworkName' },
        { displayName: 'IMEI', key: 'imei' },
        { displayName: 'SERIAL/EID', key: 'serialNumber' },
        { displayName: 'MOBILE NUMBER', key: 'mobileNumber' },
        { displayName: 'PLAN VALUE', key: 'planValue' },
        { displayName: 'EMAIL', key: 'email' },
        { displayName: 'NEW PIN', key: 'newPin' },
        { displayName: 'ACTIVATION PIN', key: 'activationPin' },
        { displayName: 'SOURCE', key: 'source' },
        { displayName: 'SIM TYPE', key: 'simType' },
        { displayName: 'TYPE', key: 'requestType' },
        { displayName: 'REMARK', key: 'remark' },
        { displayName: 'TRANSACTION ID', key: 'transactionId' },
        ...(isAdmin(tokenData) || isAdminAgent(tokenData) ? [{ displayName: 'COMPLETED BY', key: 'completedBy' }] : []),
    ];

    const filteredItems = Array.isArray(simSwapRequestList) && simSwapRequestList.length > 0 ? simSwapRequestList.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;
        // Check if any value in the object contains the filterText
        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
    }) : [];

    const handleUnLockActivation = (activationID) => {
        setunlockID(activationID)
        let data = {
            simswapID: activationID
        }
        dispatch(releaseLockSimSwapRequest(data, searchData));
        alertCancel()
    }

    const handleLockActivation = (activationID) => {
        setSelectedID(activationID)
        let data = {
            simswapID: activationID
        }
        dispatch(lockSimSwapRequest(data, searchData));
        alertCancel()
    }

    const handleCancelRequest = (activationID) => {
        setcancelID(activationID)
        let selectedActivation = simSwapRequestList.filter((item) => item.ID === activationID);
        setSelectedRow(selectedActivation[0]);
        dispatch(openCancelSimSwapModal());
        alertCancel()
    }

    const handleCompleteRequest = (activationID) => {
        setcompleteID(activationID)
        let selectedActivation = simSwapRequestList.filter((item) => item.ID === activationID);
        setSelectedRow(selectedActivation[0]);
        dispatch(openCompleteSimSwapModal());
        alertCancel()
    }

    const handleViewActivation = (activation) => {
        setFormTitle(`Picked MSISDN (${activation.MSISDN})`);
        setFormButton("Update");
        setShowMSISDNModel(true);
        setSimSwapID(activation.ID)
        setShowAlertModal(false);
        setAlertText('');
        setAlertType('');
        dispatch(getMsisdnAvilable(activation.MSISDN))
    };
    const handleCancel = () => {
        resetReset();
        setShowMSISDNModel(false);
        setSelectedMSISDN('')
    };

    const handleMsisdnSubmit = () => {
        if (selectedMSISDN) {
            const selectedObj = mdnData.find(item => item.MSISDN === selectedMSISDN);
            if (!selectedObj) return;
            const ActivationID = selectedObj.ActivationID;
            const newdata = {
                msisdn: selectedMSISDN,
                activationID: ActivationID,
                simswapID: simSwapID
            };
            dispatch(updatePickedMsisdn(newdata, searchData));
        } else {
            const newdata = {
                SimSwapID: simSwapID
            };
            dispatch(createActivationUsingSimSwap(newdata, searchData));
        }
    };

    const displayAlertModal = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
        setShowAlertModal(true);
        dispatch(resetMessage())
    };

    const data = filteredItems && filteredItems.length > 0 && filteredItems.map((activation, key) => {
        return {
            key: key + 1,
            action: <>
                {
                    isAdminOrAgent(tokenData) ? <>
                        {
                            activation.RequestStatusID === 10 ? activation.otherLockFlag === 1 ?
                                <div className='d-flex'>
                                    <>
                                        <div className="icon iq-action-icon-box rounded-circle bg-danger" onClick={() => setShowPopup(true)} style={{ cursor: "pointer" }} >
                                            <i className="ri-forbid-line"></i>
                                        </div>

                                        {/* Popup Modal */}
                                        {showPopup && (
                                            <div style={overlayStyle}>
                                                <div style={modalStyle}>
                                                    <h4>This transaction is locked by {activation.LockedByName}</h4>
                                                    <button onClick={() => setShowPopup(false)} style={buttonStyle}> Close </button>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                </div> :
                                <>
                                    {
                                        activation.lockFlag === 1 ?
                                            <div className='d-flex'>
                                                <div className="icon iq-action-icon-box rounded-circle bg-success" onClick={() => handleCompleteRequest(activation.ID)}><span data-toggle="tooltip" data-placement="top" title="Complete Request"> <i className="ri-check-line"></i></span></div>
                                                <div className="icon iq-action-icon-box rounded-circle bg-danger" onClick={() => handleCancelRequest(activation.ID)}><span data-toggle="tooltip" data-placement="top" title="Cancel Request"> <i className="ri-close-fill"></i></span></div>
                                                <div className="icon iq-action-icon-box rounded-circle bg-secondary" onClick={() => handleUnLockActivation(activation.ID)}>
                                                    {releaseLockSimSwapRequestLoading && unlockID == activation.ID ? <span className="spinner-border spinner-border-sm" style={{ marginBottom: '2px' }} role="status"></span> : <span data-toggle="tooltip" data-placement="top" title="Unlock"><i className="ri-lock-unlock-line"></i></span>}
                                                </div>
                                            </div> :
                                            <div className='d-flex'>
                                                <div className="icon iq-action-icon-box rounded-circle" style={{ background: '#2c3782', color: '#fff' }} onClick={() => handleLockActivation(activation.ID)}>
                                                    {lockSimSwapRequestLoading && selectedID == activation.ID ?
                                                        <span className="spinner-border spinner-border-sm" style={{ marginBottom: '2px' }} role="status"></span>
                                                        : <span data-toggle="tooltip" data-placement="top" title="Lock"><i className="ri-lock-fill"></i></span>}
                                                </div>
                                            </div>
                                    }
                                </> : ''
                        }
                    </> : ''
                }
            </>,
            serialNumber: activation.SerialNumber,
            NetworkName: activation.NetworkName,
            transactionId: activation.TransactionID,
            imei: activation.IMEI,
            activationPin: activation.ActivationPIN ?? '',
            newPin: activation.PIN ?? '',
            requestedDtTm: activation.RequestedDtTm !== null ? moment(activation.RequestedDtTm).tz(process.env.REACT_APP_TIMEZONE).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
            requestType: activation.RequestType,
            simType: activation.SimType,
            source: activation.SourceData,
            completedBy: activation.completedByName,
            status: <Tag
                color={`${(activation.RequestStatusID === 13) ? 'badge-danger' : (activation.RequestStatusID === 11 || (activation.RequestStatusID >= 18 && activation.RequestStatusID <= 22) || activation.RequestStatusID === 27) ? 'badge-warning' : (activation.RequestStatusID === 12) ? 'badge-success' : 'badge-secondary'}`}
                title={`${(activation.RequestStatusID === 13) ? 'Cancelled' : (activation.RequestStatusID === 11 || (activation.RequestStatusID >= 18 && activation.RequestStatusID <= 22)) ? 'Processing' : (activation.RequestStatusID === 12) ? 'Processed' : activation.RequestStatusID === 27 ? 'Assigned to Care' : 'Pending'}`}
            />,
            remark: activation.Remark,
            email: activation.CustomerEmail,
            // planValue: `$${activation.PlanValue.toFixed(2)}`,
            planValue: `$${(activation.PlanValue || 0).toFixed(2)}`,
            dpDealerName: activation.DPDealerName,
            mobileNumber: (
                <div className="d-flex align-items-center">
                    <span>{activation.MSISDN}</span>
                    {activation.lockFlag === 1 && (
                        <i
                            className="ri-edit-box-fill"
                            style={{ marginLeft: "8px", cursor: "pointer", color: "#2c3782", fontSize: "1.3rem" }}
                            title="Pick MSISDN"
                            onClick={() => handleViewActivation(activation)}
                        ></i>
                    )}
                </div>
            ),
        }
    });

    const completeSimSwapModalFunction = () => {
        return <CompleteSimSwapModalComponent row={selectedRow} search={searchData} />;
    }

    const cancelSimSwapModalFunction = () => {
        return <CancelSimSwapModalComponent row={selectedRow} search={searchData} />;
    }

    const onSubmit = (data) => {
        alertCancel()
        const newData = {
            ...data,
            toDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
            fromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
        };
        setSearchData(newData)
        dispatch(dispatch(getSimSwapRequest(newData)));
    }
    const datePickerRef = useRef(null);
    const datePickerRef2 = useRef(null);

    const openDatePicker = () => {
        datePickerRef.current.setOpen(true);
    };

    const openDatePicker2 = () => {
        datePickerRef2.current.setOpen(true);
    };

    const handleOpenAddFormModal = () => {
        dispatch(openSimSwapFormModal())
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
    }

    const exportToCSV = async () => {
        if (simSwapRequestList.length <= 0) {
            alert('No data for export');
            return;
        }
        let id = 0;
        let formatData = simSwapRequestList && simSwapRequestList.length > 0 && simSwapRequestList.map((data, ind) => {
            id = id + 1;
            let newData = {
                ID: id,
                'Date': data.RequestedDtTm !== null ? moment(data.RequestedDtTm).tz(process.env.REACT_APP_TIMEZONE).format(`${process.env.REACT_APP_DATE_FORMAT}`) : '',
                'DP Dealer Name': data.DPDealerName,
                'Request Status': (data.RequestStatusID === 13 ? 'Cancelled' : (data.RequestStatusID === 11 || (data.RequestStatusID >= 18 && data.RequestStatusID <= 22)) ? 'Processing' : data.RequestStatusID === 12 ? 'Processed' : data.RequestStatusID === 27 ? 'Assigned to Care' : 'Pending'),
                'Network Name': data.NetworkName,
                IMEI: data.IMEI,
                'Serial Number': data.SerialNumber,
                MSISDN: data.MSISDN,
                'Plan Value': `$${(data.PlanValue || 0).toFixed(2)}`,
                Email: data.CustomerEmail,
                'New PIN': data.PIN ?? '',
                'Activation PIN': data.ActivationPIN ?? '',
                Source: data.SourceData,
                'Sim Type': data.SimType,
                Type: data.RequestType,
                Remark: data.Remark,
                'Transaction ID': data.TransactionID,
                'Completed By': data.completedByName,
            }
            return newData
        })

        if (data && data.length > 0) {
            const ws = XLSX.utils.json_to_sheet(formatData);
            const wb = { Sheets: { 'simSwapRequestList': ws }, SheetNames: ['simSwapRequestList'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            await FileSaver.saveAs(data, 'SIM_Swap_Report' + fileExtension);
        }
    }

    return (
        <>
            <CardLayout title="SIM Swap Request">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-row">
                        <div className="col-lg-2 col-md-4 mb-2">
                            <label>Select Network</label>
                            <select className="form-control" id="networkID" name="networkID" {...registerFilter("networkID", {
                            })} >
                                <option value="">All</option>
                                {
                                    networkResult && networkResult.length > 0 && networkResult.filter((item) => item.IsActive == 1).map((item, index) => {
                                        return <option value={item.ID}>{item.NetworkName}</option>
                                    })
                                }
                            </select>
                        </div>
                        <div className="col-lg-2 col-md-4 mb-2">
                            <label>Select Status</label>
                            <select className="form-control" id="statusID" name="statusID" placeholder="Select"  {...registerFilter("statusID", {
                            })} >
                                {shortCodeResult && shortCodeResult.length > 0 && <option value="" name="All">All</option>}
                                <option value={'10'} name={'Pending'}>Pending</option>
                                {shortCodeResult && shortCodeResult.length > 0 && shortCodeResult.filter(item => item.ID != 10).map((item, ind) => (
                                    <option value={item.ID} name={item.Value}>{item.Value}</option>
                                ))}
                            </select>
                        </div>
                        {
                            (isAdmin(tokenData) || isAdminAgent(tokenData)) &&
                            <div className="col-lg-2 col-md-4  mb-2">
                                <label>Select Dealer</label>
                                <select className="form-control" id="dealerID" name="dealerID"  {...registerFilter("dealerID", {
                                })} >
                                    <option value="" name="All">All</option>
                                    {
                                        dealerResult && dealerResult.length && dealerResult.map((item) => {
                                            return <option value={item.ID} key={`dealer${item.ID}`}>{item.DealerName}</option>
                                        })
                                    }
                                </select>
                            </div>
                        }

                        <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                            <label>From Date</label>
                            <Calendar2LineIcon onClick={openDatePicker} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                            <DatePicker
                                ref={datePickerRef}
                                selected={fromDate}
                                className="form-control"
                                onChange={(date) => setFromDate(date)}
                                dateFormat="yyyy-MM-dd"
                                name="fromDate"
                                showMonthDropdown
                                showYearDropdown
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                }}
                                value={fromDate}
                            />
                        </div>

                        <div className="col-lg-2 col-md-4 mb-2 d-flex flex-column">
                            <label>To Date</label>
                            <Calendar2LineIcon onClick={openDatePicker2} size={'1.5rem'} style={{ cursor: 'pointer', position: 'absolute', 'top': '36px', right: '12px', zIndex: 1 }} />
                            <DatePicker
                                ref={datePickerRef2}
                                selected={toDate}
                                className="form-control center"
                                onChange={(date) => setToDate(date)}
                                dateFormat="yyyy-MM-dd"
                                name="todate"
                                showMonthDropdown
                                showYearDropdown
                                onKeyDown={(e) => {
                                    e.preventDefault();
                                }}
                                value={toDate}
                            />
                        </div>

                        <div className="col-lg-2 col-md-4 mb-2">
                            <label>SIM/TXN/MSISDN</label>
                            <input
                                type="text"
                                className="form-control"
                                id="serialNumber"
                                name="serialNumber"
                                placeholder="SIM/TXN/MSISDN"
                                {...registerFilter("serialNumber")}
                            />
                        </div>

                        <div className={'col-lg-2 col-md-4'}>
                            <div className={"mt-2 d-flex justify-content-start activation-search-btn"}>
                                <Button title="Search" style="minWidth:80px" buttonClass={`btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} buttonType='submit' />
                            </div>
                        </div>

                    </div>
                </form>
                <hr />

                <div className="row align-items-baseline">
                    <div className='col-lg-3 col-md-6  od-2'>
                        <SearchBar onFilter={handleFilterChange} filterText={filterText} />
                    </div>
                    <div className='col-lg-9 col-md-6 d-flex justify-content-end align-items-center'>
                        <SideButtons title="Add SIM Swap" buttonStyle="primary" onClick={handleOpenAddFormModal} />

                        {simSwapRequestList.length > 0 && (
                            <Button
                                onClick={exportToCSV}
                                title="Export"
                                icon={<DownloadCloud2sLineIcon size={15} />}
                                style="minWidth:120px"
                                buttonClass="btn acti-export-btn-v acti-ex-btn ml-2 font-weight-bold text-white"
                            />
                        )}

                    </div>

                </div>

                {completeSimSwapModal ? completeSimSwapModalFunction() : ''}
                {cancelSimSwapModal ? cancelSimSwapModalFunction() : ''}

                {showAlert && !pickedMDNError && <div className='mt-4 mb-0'><Alert type={alertType} text={alertText} closeBtn={alertCancel} /></div>}
                <Table columns={columns} loading={simSwapRequestLoading} data={data} pagination={true} />
                <SimSwapFormModal />

                <Modal
                    showModal={showMSISDNModel}
                    title={formTitle}
                    onHide={handleCancel}
                    width={500}
                    showFooter={false}
                >
                    {showAlertModal && (<Alert type={alertType} text={alertText} closeBtn={alertCancel} />)}
                    {getMDNLoading ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }} >
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleMDNSubmit(handleMsisdnSubmit)}>
                            {mdnData && Array.isArray(mdnData) && mdnData.length > 0 && mdnData[0].Status !== 0 ? (
                                <div className="form-row">
                                    {mdnData.map((item, index) => (
                                        <div className="col-md-4 mb-3" key={index}>
                                            <div className="border p-2 rounded d-flex align-items-center">
                                                <input
                                                    type="radio"
                                                    name="selectedMSISDN"
                                                    className="mdn-radio-btn"
                                                    value={item.MSISDN}
                                                    checked={selectedMSISDN === item.MSISDN}
                                                    onChange={() => setSelectedMSISDN(item.MSISDN)}
                                                    style={{ marginRight: "10px" }}
                                                />
                                                <div className="msis-div-radio">
                                                    <strong>{item.MSISDN}</strong> <br />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "150px" }} >
                                    <h6 className="text-danger text-center" style={{ fontWeight: "bold", fontSize: "18px" }} >
                                        {mdnData && mdnData[0]?.Status === 0 ? mdnData[0].Message : getMDNMessage}
                                    </h6>
                                </div>
                            )}
                            <div className="text-right row mt-3">
                                <div className="col-md-12">
                                    <button type="button" className="btn btn-secondary mr-2" onClick={handleCancel} > Close </button>

                                    {mdnData && Array.isArray(mdnData) && mdnData.length > 0 && mdnData[0].Status !== 0 ? (
                                        <Button title={formButton} style="minWidth:80px" loading={pickedMDNLoading} buttonClass="btn btn-primary" buttonType="submit" disable={!selectedMSISDN} />
                                    ) : (
                                        mdnData && mdnData[0]?.Status === 0 && (
                                            <Button title="Fresh Activation" style="minWidth:80px" loading={createActivationUsingSimSwapLoading} buttonClass="btn btn-primary" buttonType="submit" />
                                        )
                                    )}
                                </div>
                            </div>
                        </form>
                    )}
                </Modal>

            </CardLayout>
        </>
    )
}

const styles = {
    multilineActivation: {
        color: "#e74c3c",
        border: "1px solid",
        padding: "3px 5px",
        borderRadius: "9px"
    }
}
const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
};

const modalStyle = {
    backgroundColor: "white",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0px 4px 10px rgba(0,0,0,0.25)",
    textAlign: "center",
};

const buttonStyle = {
    marginTop: "20px",
    padding: "10px 20px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
};

export default ActivationRequest;